<template>
  <div v-if="items" :id="'select-plus'+_uid" class="select-plus d-block" style="max-width: 100%">
    <span v-if="label" class="ba-w-100 ba-custom-label">{{ label }}</span>
    <div class="dropdown">
      <button class="dropdown-toggle nano-toggle select-plus-picker" @click="focus()" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <template v-if="selectedVal">
          <img v-if="selectedVal.img" :src="selectedVal.img"> {{ selectedVal.label }}
        </template>
        <template v-else>{{ $t('ct-select') }}</template>
        <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon sort-icon"/>
      </button>
      <p class="text-danger invalid-fb">{{ invalidFeedback }}</p>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <div class="select-plus-header">
          <div class="input-group mt-2">
            <span class="input-group-prepend bg-white border-right-0">
              <span class="input-group-text bg-transparent">
                <i class="mdi mdi-magnify" />
              </span>
            </span>
            <input
              ref="pesquisa"
              :placeholder="$t('ct-search')" v-model="search"
              class="form-control border-left-0"
            >
          </div>
        </div>
        <div class="nano">
          <div class="nano-content">
            <a
              v-for="(item, index) in filteredItems"
              :key="index"
              :class="{'select-with-subtitle' : !!item.url, 'active': item.value == selected}"
              class="select-plus-item"
            >
              <div v-if="item.is_premium" class="premium-template-tab">
                <i class="svg-icon svgi-crown" />
                <b>Premium</b>
              </div>
              <template v-if="item.img">
                <div
                  v-if="item.img"
                  :style="`background-image: url('${item.img}')`"
                  class="image-preview"
                />
                <p>{{ item.label }}</p>
                <span v-if="item.url">{{ item.url }}</span>
              </template>
              <span v-else>{{ item.label }}</span>
              <div :class="item.img ? 'box-template-overlay' : 'box-overlay'">
                <a
                  v-if="item.title"
                  :href="item.preview_url"
                  target="_blank"
                  class="ba-sm ba-btn	ba-blue">
                  <builderall-icon code='eye' style="--builderall-icon-size: 20px;"></builderall-icon>
                  <!-- {{ $t('ct-preview') }} -->
                </a>
                <a
                  v-if="item.is_premium && !item.has_premium_template_access && !isPremiumUser"
                  :href="'https://checkout.builderall.com/payment/premium-template?tp_slug='+item.title"
                  class="btn btn-warning text-light"
                >
                  {{ $t('ct-buy') }}
                </a>
                <a
                  v-else-if="item.is_premium && !item.has_premium_template_access && isPremiumUser"
                  class="btn btn-warning text-light"
                  @click.stop.prevent="unlockPremiumTemplate(item.title)"
                >
                  {{ $t('ct-unlock') }}
                </a>
                <a v-else class="btn btn-default btn-select" @click="changeSelected(item)">
                  {{ $t('ct-select') }}
                </a>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectPlusComponent',
  props: ['label', 'items', 'selected', 'invalidFeedback'],
  data() {
    return {
      search: '',
      isPremiumUser: false
    }
  },
  computed: {
    officeUrl() {
      return typeof process.env.OFFICE_URL !== 'undefined' ? process.env.OFFICE_URL : "https://office.builderall.com";
    },
    selectedVal() {
      $('#select-plus'+this._uid).removeClass('is-invalid');
      if(typeof this.selected === undefined || this.selected == null) {
        return {
          'img': null,
          'label': this.$t('ct-select')
        };
      }
      if(this.items && this.selected != null) {
        var vm = this;
        return this.items.filter(function(item) {
          return item.value == vm.selected;
        })[0];
      }
      return this.selected;
    },
    filteredItems() {
      if(this.search != '') {
        return this.items.filter(item => {
          return item.label.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
        });
      }
      return this.items;
    },
    value() {
      return 5;
    }
  },
  mounted() {
    const email = localStorage.getItem("email");
    if(email){
      fetch(`${this.officeUrl}/br/office/user/info/${email}`)
        .then(response => response.json())
        .then(response => {
          if (response.status == "success") {
            // @Thais Andreu 13-03-26 E o Pedro quer que os premium templates estejam disponíveis de graça pra o 14 days trial.
            const premiumPlans = ['premium-plus-plan', 'wp-premium-plus-plan', 'premium-plus-plan-trial', 'test-usd', 'test-brl', 'test-eur'];
            const specialWpPlans = ['special-premium-wp', 'special-funnel-club-wp'];
            if (
              premiumPlans.includes(response.data.active_plan.slug) ||
              (specialWpPlans.includes(response.data.active_plan.slug) && response.data.created > '2024-12-12 00:00:00')
            ) {
              this.isPremiumUser = true;
            }
          }
        });
    }
  },
  methods: {
    unlockPremiumTemplate(title){
      this.$emit('unlock', title);
    },
    focus() {
      vm = this;
      setTimeout(function() {
        $(vm.$refs.pesquisa).focus();
      }, 250);
    },
    changeSelected(val) {
      this.$emit('value', val);
    }
  }
};
</script>

<style lang="scss">
  .select-plus {
    padding: 0;
    padding-bottom: 15px;

    &.is-invalid {

      .invalid-fb {
        display: block;
      }

      .select-plus-picker {
        border: 1px solid red;
      }
    }

    .dropdown-toggle::after {
      display: none;
    }

    .select-plus-picker {
      color: #94a4ba;
      background-color: #eff2f8;
      border: 0;
      border-radius: 6px;
      padding: 9.6px 12.8px;
      // margin: 0px;
      width: 100%;
      text-align: left;

      img {
        height: 30px;
        margin-right: 15px;
      }
      .font-awesome-icon {
        margin-top: 2px;
        color: #ADADAD;
        float: right;
      }
    }
    .dropdown-menu {
      padding: 0;
      background-color: #FCF7F7;
      box-shadow: 0px 3px 5px #00000029;
      border-radius: 3px;
      margin-top: -40px;
      width: 100%;
      height: 235px;

      .select-plus-header {
        padding: 15px 15px 7.5px 15px;
      }

      span.title {
        font-size: 15px;
      }

      .form-control, .input-group-text, .form-control:focus {
        box-shadow: none;
        border-color: #E0E0E0 !important;
        padding-left: 0;
      }

      .input-group-text {
        padding: 0 7.5px;
        text-align: center;
        .mdi {
          font-size: 20px;
        }
      }

      .nano-content, .nano {
        height: 162px;
      }

      .select-plus-item {
        display: flex;
        position: relative;
        width: 100%;
        align-items: center;
        padding: 15px;
        text-decoration: none;

        .premium-template-tab {
          position: absolute;
          top: 10px;
          left: 5px;
          border-radius: 16px;
          padding: 2px 6px;
          border: 1px solid #FFC35C;
          background-color: #FFF6E5;
          display: flex;
          align-items: center;
          gap: 7px;
          b {
            font-size: 10px;
            color: #101623;
          }
        }

        .box-overlay {
          display: flex;
          //flex-direction: column;
          align-items: center;
          justify-content: flex-end;
          gap: 1px;
          position: absolute;
          visibility: hidden;
          background: #00000084 0 0 no-repeat padding-box;
          box-shadow: 0 3px 6px #00000029;
          border-radius: 5px;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          margin: 0 auto;
          text-align: center;
          opacity: 0;
          transition: all 0.4s;

          a{
            cursor: pointer;
          }

          .btn-outline-light, .btn-warning, .btn-select{
            width: 124px;
            height: 30px;
            border-radius: 10px;
            white-space: nowrap;
          }

          .btn-outline-light {
            background: #FFFFFF 0% 0% no-repeat padding-box;
            box-shadow: 0.62px 0.79px 2px #1E120D1A;
            border-radius: 14px;
            opacity: 1;
            text-align: left;
            font: 13px/16px Lato;
            letter-spacing: 0px;
            color: #0080FC;
            text-transform: uppercase;
          }

          .btn-select {
            background: #0080FC 0% 0% no-repeat padding-box;
            box-shadow: 0 0 9px #26242429;
            border-radius: 10px;
            opacity: 1;
            font: ExtraBold 13px/16px Muli;
            letter-spacing: 0.39px;
            color: #FFFFFF;
            height: 33px !important;
            min-height: 33px !important;
          }
        }

        .box-template-overlay {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 12px;
          position: absolute;
          visibility: hidden;
          background: #00000084 0 0 no-repeat padding-box;
          box-shadow: 0 3px 6px #00000029;
          border-radius: 5px;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          margin: 0 auto;
          text-align: center;
          opacity: 0;
          transition: all 0.4s;

          a{
            cursor: pointer;
          }

          .btn-outline-light, .btn-warning, .btn-select{
            min-width: 124px;
            height: 43px;
            border-radius: 14px;
            white-space: nowrap;
          }

          .btn-outline-light {
            background: #FFFFFF 0% 0% no-repeat padding-box;
            box-shadow: 0.62px 0.79px 2px #1E120D1A;
            border-radius: 14px;
            opacity: 1;
            text-align: left;
            font: 13px/16px Lato;
            letter-spacing: 0px;
            color: #0080FC;
            text-transform: uppercase;
          }

          .btn-select {
            background: #0080FC 0% 0% no-repeat padding-box;
            box-shadow: 0 0 9px #26242429;
            border-radius: 14px;
            opacity: 1;
            font: ExtraBold 13px/16px Muli;
            letter-spacing: 0.39px;
            color: #FFFFFF;
          }
        }

        &.active {
          border-right: 5px solid #0080FC;
        }

        &:hover {
          background-color: #EDEDED;

          .box-template-overlay{
            visibility: visible;
            opacity: 1;
          }

          .box-overlay{
            visibility: visible;
            opacity: 1;
          }

          .premium-template-tab{
            display: none;
          }
        }

        img {
          height: 26px;
          margin-right: 12px;
          border-radius: 14px 14px 0 0;
        }
      }
    }

    .invalid-fb {
      display: none;
    }
  }

  .select-plus.background-white {
    .dropdown-menu {
      background-color: #FFF;
    }
  }

  .select-plus.with-image-preview {
    .dropdown-menu {
      background-color: #FFF;
      height: auto;

      .nano-content, .nano {
        height: 225px;
      }
    }

    .nano-content {
      display: grid;
      grid-template-columns: 1fr;
      grid-column-gap: 15px;
      grid-row-gap: 5px;

      padding: 0 15px 10px;
      margin: 0;

      @media (min-width: 600px) {
        grid-template-columns: 1fr;
      }
      @media (min-width: 1200px) {
        grid-template-columns: 1fr 1fr;
      }

      .select-plus-item {
        display: flex;
        flex-direction: column;
        align-items: start;
        text-align: left;
        background: #FFF;
        border-radius: 16px;
        border: 1px dotted transparent;
        box-shadow: 0 3px 3px #D4D4D466;
        max-width: 197px;

        &.active {
          box-shadow: 0px 2px 10px #0000001A;
          border: 2px solid #2690F7;
        }

        &.select-with-subtitle {
          max-height: 200px;
        }

        padding: 0 0 5px;
        margin-bottom: 10px;

        &:hover {
          background: #FFF;
          border-color: #6799ED;
        }

        .image-preview {
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
          width: 196px;
          height: 150px;
          border-radius: 14px 14px 0 0;
          box-shadow: 0 3px 5px #D4D4D466;
        }

        p {
          font-family: 'Lato';
          font-weight: 900;
          font-size: 16px;
          text-transform: uppercase;
          color: #5A5959;

          width: 200px;

          padding: 8px 5px 0;
          margin-bottom: 0;

          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        span {
          color: #A3A7A9;
          width: 200px;
          padding: 0 5px;

          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/SelectPlus.vue